import { isPositive } from '@/general/utils/isPositive';

export function isNegative(value: any): boolean {
  return !isPositive(value);
}
